import { Injectable } from '@angular/core';
import { FrameContext } from '@farris/devkit';
import { EntityTraversingService } from './entity-traversing.service';
import { EntityManipulationService } from './entity-manipulation.service';
import { EntityAggregationService} from './entity-aggregation.service';

/**
 * å®ä½æå¡
 * @scope FrameComponent
 */
@Injectable()
class EntityService {

  private traversingService: EntityTraversingService;

  private manipulationService: EntityManipulationService;

  private aggregationService: EntityAggregationService;

  constructor(private frameContext: FrameContext) {
    const injector = this.frameContext.injector;
    this.traversingService   = injector.get<EntityTraversingService>(EntityTraversingService);
    this.manipulationService = injector.get<EntityManipulationService>(EntityManipulationService);
    this.aggregationService  = injector.get<EntityAggregationService>(EntityAggregationService);
  }

  /**
   * è·åpathå¯¹åºçå±æ§å¼
   */
  public getPropValue(path: string[]): any {
    return this.traversingService.getPropValue(path);
  }

  /**
   * è®¾ç½®pathå¯¹åºçå±æ§å¼
   */
  public setPropValue(path: string[], value: any): void {
    return this.manipulationService.setPropValue(path, value);
  }

  /**
   * è®¾ç½®pathå¯¹åºçEntityæ°æ®
   */
  public getEntityData(path: string[]): any {
    return this.traversingService.getEntityData(path);
  }

  /**
   * è®¾ç½®pathå¯¹åºçEntityListæ°æ®
   */
  public getEntityListData(path: string[]): any {
    return this.traversingService.getEntityListData(path);
  }

  /**
   * è·åpathå¯¹åºEntityListè®°å½æ°
   */
  public count(path: string[]): number {
    return this.aggregationService.count(path);
  }

  /**
   * è·åpathå¯¹åºå±æ§çåè®¡å¼
   */
  public sum(path: string[]): number {
    return this.aggregationService.sum(path);
  }

  /**
   * è·åpathå¯¹åºå±æ§çå¹³åå¼
   */
  public avg(path: string[]): number {
    return this.aggregationService.avg(path);
  }

  /**
   * è·åpathå¯¹åºå±æ§çæå¤§å¼
   */
  public max(path: string[]): number {
    return this.aggregationService.max(path);
  }

  /**
   * è·åpathå¯¹åºå±æ§çæå°å¼
   */
  public min(path: string[]): number {
    return this.aggregationService.min(path);
  }
}

export { EntityService };
